import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async addClient(data) {
    const response = await $api.post(`/clients`, data);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getClients(teamId) {
    const response = await $api.get(`/teams/${teamId}/clients`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getActiveClients(teamId) {
    const response = await $api.get(`/teams/${teamId}/active-clients`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getClient(clientId) {
    const response = await $api.get(`/clients/${clientId}`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async getNewCode() {
    const response = await $api.get(`/clients/code`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async getNewPassword() {
    const response = await $api.get(`/clients/password`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async updateClient(clientId, data) {
    const response = await $api.patch(`/clients/${clientId}`, data);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async closeClient(clientId, data) {
    const response = await $api.patch(`/clients/${clientId}/status`, data);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async resetPassword(clientId) {
    const response = await $api.patch(`/clients/${clientId}/reset-password`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async resetTeamPasswords(teamId) {
    const response = await $api.patch(`/clients/team/${teamId}/reset-team-passwords`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },
};
